"use strict";

// parts
import "./parts/_accordion.js";
import "./parts/_countup.js";
import "./parts/_drawer.js";
import "./parts/_fixed-viewport.js";
import "./parts/_inquiry-form-confirm.js";
import "./parts/_observer.js";
import "./parts/_scroll-hint.js";
